import { Link } from "react-router-dom";
import { PPP_TYPE_BADGE } from "@/components/ppp/ppp-constants";
import { PppLock } from "@/components/ppp/PppLock";
import { cn } from "@/lib/utils";
import { PriorityPppRef } from "@/types";
import { Layers } from "lucide-react";

export function PppGroupHeader({ ppp, count }: { ppp: PriorityPppRef | null; count: number }) {
    return (
        <div className="flex items-center gap-2 pt-2 pb-1 text-sm">
            <Layers className="h-3.5 w-3.5 text-muted-foreground" />
            {ppp ? (
                <>
                    <span className={cn("inline-flex items-center rounded border px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide", PPP_TYPE_BADGE[ppp.type])}>
                        {ppp.type}
                    </span>
                    <Link to="/ppp" className="font-semibold text-foreground hover:underline">{ppp.name}</Link>
                    {ppp.isConfidential && <PppLock />}
                </>
            ) : (
                <span className="font-semibold text-muted-foreground">Unlinked</span>
            )}
            <span className="text-xs text-muted-foreground">· {count}</span>
        </div>
    );
}
